<template>
  <b-modal
    :title="$t('AiTexter.LegalInformationTitle')"
    class="legal-information-modal-container"
    header-close-content=""
    body-class="legal-information-modal"
    v-model="_showModal"
    centered
    no-close-on-backdrop>
    <b-row>
      <b-col cols="2" class="d-flex justify-content-center align-items-center">
        <Icon icon="WatcherWarning" style="font-size: 3rem"></Icon>
      </b-col>
      <b-col cols="10">
        <div class="notificationText">{{ $t("AiTexter.LegalInformationNotification") }}</div>
        <b-checkbox style="margin-top: 12px" v-model="viewModel.dontShowMessageAgain">{{ $t("AiTexter.DontShowMessage") }} </b-checkbox>
      </b-col>
    </b-row>
    <template #modal-footer="{ cancel }">
      <div class="footer">
        <div class="footer-actions">
          <div class="row">
            <b-btn variant="primary" @click="sendNotificationStatus()" data-cy="ai-texter-legal-information-accept-button">{{ $t("AiTexter.Ok") }} </b-btn>
            <b-btn @click="cancel">{{ $t("AiTexter.Cancel") }}</b-btn>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script lang="ts" setup>
import Icon from "@common/components/Icon.vue";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{ showModal?: boolean }>();
const { t: $t } = useI18n();
const emit = defineEmits(["update:showModal", "notificationStatus"]);

type ViewModel = {
  dontShowMessageAgain: boolean;
};

const viewModel = reactive<ViewModel>({
  dontShowMessageAgain: false
});

const _showModal = computed({
  get: () => {
    return props.showModal;
  },
  set: (nv) => {
    emit("update:showModal", nv);
  }
});

const sendNotificationStatus = () => {
  emit("notificationStatus", viewModel.dontShowMessageAgain);
};
</script>
